import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { SvgIconComponent } from 'angular-svg-icon';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AuthService } from '../../../modules/auth/_services/auth.service';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { LanguageSelectorComponent } from '../../../modules/core/components/language-selector/language-selector.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-haeder',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SvgIconComponent,
    OverlayPanelModule,
    LanguageSelectorComponent,
    TranslateModule
  ],
  templateUrl: './haeder.component.html',
  styleUrl: './haeder.component.scss'
})
export class HaederComponent implements OnInit {
  fileServerUrl = environment.fileServerUrl;
  searchText: any = '';
  searchSubject: Subject<string> = new Subject<string>();

  @Input() showToggler: boolean = true;
  @Input() showSearch: boolean = true;
  @Input() sidebarOpen!: boolean;
  @Output() sidebarToggle = new EventEmitter<void>();
  @Output() mobileMenuToggle = new EventEmitter<void>();

  constructor(
    public authService: AuthService
  ) { }

  ngOnInit(): void { }

  onToggleSidebar() {
    this.sidebarToggle.emit();
  }

  onToggleMobileMenu() {
    this.mobileMenuToggle.emit();
  }

  search() {
    this.searchSubject.next(this.searchText);
  }

  logout() {
    this.authService.logout();
  }

}
